import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle } from 'lucide-react';
export function Requirements() {
  const reqs = ['Completed Loan Application Form', 'Confirmation Letter of Employment', '3 Months Bank Statement', 'Omang / Passport', 'Work & Residence Permit (if applicable)', 'KYC Documentation'];
  return <Section bg="white" data-id="element-390">
      <div className="bg-navy rounded-2xl p-8 md:p-12 text-white overflow-hidden relative" data-id="element-391">
        {/* Decorative circles */}
        <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-white/5 rounded-full blur-3xl" data-id="element-392"></div>
        <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-40 h-40 bg-gold/10 rounded-full blur-3xl" data-id="element-393"></div>

        <div className="grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-394">
          <div data-id="element-395">
            <h3 className="text-3xl font-heading font-bold mb-6" data-id="element-396">
              Ready to Apply?
            </h3>
            <p className="text-gray-300 mb-8" data-id="element-397">
              Ensure you have the following documents ready to speed up your
              application process. We make it simple and straightforward.
            </p>
            <button onClick={() => window.location.href = '#apply'} className="bg-gold text-navy font-bold py-3 px-8 rounded-lg hover:bg-white transition-colors" data-id="element-398">
              Start Application
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/10" data-id="element-399">
            <h4 className="font-bold text-lg mb-4 text-gold" data-id="element-400">
              Loan Requirements
            </h4>
            <ul className="space-y-3" data-id="element-401">
              {reqs.map((req, index) => <li key={index} className="flex items-start" data-id="element-402">
                  <CheckCircle className="h-5 w-5 text-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-403" />
                  <span className="text-gray-200 text-sm" data-id="element-404">{req}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}